import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Section } from '../../models/menu.interfaces';

@Component({
  selector: 'idp-section-header',
  standalone: true,
  imports: [NgIf],
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent {
  @Input() details: Section = {} as Section;
}
